import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Stack,
  Paper,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  CircularProgress,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Autocomplete from "@mui/material/Autocomplete";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import { NumericFormat } from "react-number-format";

import GeneralContext from "../GeneralContext/GeneralContext";
import SnackbarContext from "../GeneralContext/SnackbarContext";
import axios from "../../api/axios";

import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import InputFile from "../GeneralComponents/InputFile";
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES } from "@mui/x-date-pickers/locales";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import dayjs from "dayjs";
import "dayjs/locale/es";

const titleStepSx = {
  fontWeight: 700,
  textAlign: "center",
  fontSize: "0.9rem",
};

const bodyStepSx = {
  textAlign: "center",
  fontSize: "0.78rem",
  color: "rgba(0,0,0,0.72)",
  maxWidth: "46rem",
  margin: "0 auto",
  lineHeight: 1.45,
};

const headCellSx = {
  fontWeight: 700,
  fontSize: "0.68rem",
  color: "rgba(0,0,0,0.62)",
  whiteSpace: "normal",
  lineHeight: 1.1,
  paddingTop: "0.65rem",
  paddingBottom: "0.65rem",
};

const emptyCellSx = {
  height: 92,
  color: "rgba(0,0,0,0.42)",
  fontSize: "0.76rem",
  textAlign: "center",
};

const selectedStep2RowSx = {
  backgroundColor: "#F4D8CF",
};

const disabledPrimaryButtonSx = {
  opacity: 1,
  backgroundColor: "#9DB7DC !important",
  color: "#fff !important",
};

function EmptyTableRow({ colSpan, text, height = 92 }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ ...emptyCellSx, height }}>
        {text}
      </TableCell>
    </TableRow>
  );
}

function estadoPagoLabel(v) {
  if (v === "Facturar") return "Facturando";
  if (v === "Devengar") return "Devengando";
  if (v === "Facturando") return "Facturando";
  if (v === "Devengando") return "Devengando";
  return "No Facturando";
}

function estadoServicioLabel(v) {
  if (v === "Activo" || v === "Alta" || v === "Conectado") return "Alta";
  if (v === "NYA" || v === "En proceso") return "En proceso";
  return "Baja";
}

function servicioColor(v) {
  const label = estadoServicioLabel(v);
  if (label === "Alta") return "#41AE43";
  if (label === "En proceso") return "#ABABB5";
  return "#FB3B3B";
}

function mapOficioOption(item) {
  return {
    ...item,
    id: item?.id ?? item?.numero_oficio,
    numero_oficio: String(item?.numero_oficio ?? ""),
    fecha_oficio: item?.fecha_oficio ?? null,
    label: `Buscar oficio ${
      item?.tipo_oficio === "BAJA" ? "de Baja" : "de Inicio de Servicio"
    } ${item?.numero_oficio ?? ""}`,
  };
}

function buildEmptyRectificacionRow(originalRow) {
  return {
    rbd_original: String(originalRow?.rbd ?? ""),
    rbd_reemplazo: "",
    id_zona_original: originalRow?.id_zona ?? "",
    id_zona_reemplazo: "",
    convocatoria_original: originalRow?.convocatoria ?? "",
    convocatoria_reemplazo: "",
    operador_original: originalRow?.operador ?? "",
    operador_reemplazo: "",
    estado_pago_original: originalRow?.estado_pago ?? "",
    estado_pago_reemplazo: "",
    estado_servicio_original: originalRow?.estado_servicio ?? "",
    estado_servicio_reemplazo: "",
    motivo_rectificacion: originalRow?.motivo_baja ?? "",
    replacement_loaded: false,
  };
}

export default function ParqueRectificacion() {
  const { pageTitle, setPageTitle, setDrawerHidding } = useContext(GeneralContext);
  const openSnackbar = useContext(SnackbarContext);

  const [loadingInit, setLoadingInit] = useState(true);
  const [loadingOficio, setLoadingOficio] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const [loadingReplacementIndex, setLoadingReplacementIndex] = useState(null);

  const [oficiosInicio, setOficiosInicio] = useState([]);
  const [oficiosBaja, setOficiosBaja] = useState([]);

  const [selectedOficioInicio, setSelectedOficioInicio] = useState(null);
  const [selectedOficioBaja, setSelectedOficioBaja] = useState(null);

  const [oficioSeleccionado, setOficioSeleccionado] = useState(null);
  const [oficioRbds, setOficioRbds] = useState([]);

  const [selectedOldRbd, setSelectedOldRbd] = useState(null);
  const [rectificaciones, setRectificaciones] = useState([]);

  const [formData, setFormData] = useState({
    numero_oficio_rectificacion: "",
    fecha_oficio_rectificacion: null,
  });

  const [rectificacionFile, setRectificacionFile] = useState();
  const [evErrorFile, setEvErrorFile] = useState(false);
  const [evErrorFecha, setEvErrorFecha] = useState(false);

  const fileRef = useRef(null);

  const links = [
    { name: "Estado de Parque", path: "/parque_lista" },
    { name: "Rectificación", path: "/parque_rectificacion" },
  ];

  useEffect(() => {
    setPageTitle("Rectificación");
  }, [pageTitle, setPageTitle]);

  useEffect(() => {
    setDrawerHidding(false);
  }, [setDrawerHidding]);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        setLoadingInit(true);

        const [inicioResp, bajaResp] = await Promise.all([
          axios.getOficioPorTipos("INICIO_SERVICIO"),
          axios.getOficioPorTipos("BAJA"),
        ]);

        if (!alive) return;

        const inicioPayload = inicioResp?.data ?? inicioResp;
        const bajaPayload = bajaResp?.data ?? bajaResp;

        const inicio = Array.isArray(inicioPayload?.oficios)
          ? inicioPayload.oficios.map(mapOficioOption)
          : [];

        const baja = Array.isArray(bajaPayload?.oficios)
          ? bajaPayload.oficios.map(mapOficioOption)
          : [];

        setOficiosInicio(inicio);
        setOficiosBaja(baja);
      } catch (error) {
        if (!alive) return;
        setOficiosInicio([]);
        setOficiosBaja([]);
        openSnackbar?.("No se pudo cargar la data inicial.", "error");
      } finally {
        if (alive) setLoadingInit(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [openSnackbar]);

  const setFileRectificacion = (archivo) => {
    setEvErrorFile(!archivo);
    setRectificacionFile((prev) => ({
      ...prev,
      archivo,
    }));
  };

  const resetLoadedData = () => {
    setOficioSeleccionado(null);
    setOficioRbds([]);
    setSelectedOldRbd(null);
    setRectificaciones([]);
  };

  const mapDetalleOficioRows = (rows = []) => {
    return rows.map((row) => ({
      rbd: String(row?.rbd ?? ""),
      id_zona: row?.id_zona ?? "",
      convocatoria: row?.convocatoria ?? "",
      operador: row?.operador ?? row?.nombre_operador ?? "",
      estado_pago: row?.estado_pago ?? "",
      estado_servicio:
        row?.estado_servicio ??
        row?.servicio_conectividad ??
        "",
      motivo_baja: row?.motivo_baja ?? row?.motivo ?? "",
    }));
  };

  const handleCargarDatosOficio = async (tipo) => {
    const selected = tipo === "INICIO_SERVICIO" ? selectedOficioInicio : selectedOficioBaja;

    if (!selected?.numero_oficio) {
      openSnackbar?.("Debe seleccionar un oficio.", "warning");
      return;
    }

    try {
      setLoadingOficio(true);

      /*
        Ajusta este endpoint al contrato real.
        Idealmente:
        axios.getOficioRectificacionDetalle({
          tipo_oficio,
          numero_oficio
        })

        respuesta:
        {
          oficio: {...},
          rbds: [...]
        }
      */
      const response = await axios.getOficioRectificacionDetalle({
        tipo_oficio: tipo,
        numero_oficio: selected.numero_oficio,
      });

      const payload = response?.data ?? response;

      setOficioSeleccionado({
        ...(payload?.oficio ?? selected),
        tipo_oficio: payload?.oficio?.tipo_oficio ?? tipo,
      });

      setOficioRbds(mapDetalleOficioRows(payload?.rbds ?? []));
      setSelectedOldRbd(null);
      setRectificaciones([]);

      if (!(payload?.rbds ?? []).length) {
        openSnackbar?.("El oficio no tiene RBD asociados.", "warning");
      }
    } catch (error) {
      resetLoadedData();
      openSnackbar?.("No se pudo cargar la información del oficio.", "error");
    } finally {
      setLoadingOficio(false);
    }
  };

  const handleSelectOldRbd = (row) => {
    const rbd = String(row?.rbd ?? "");
    setSelectedOldRbd(rbd);

    setRectificaciones((prev) => {
      const exists = prev.some((x) => String(x.rbd_original) === rbd);
      if (exists) return prev;
      return [...prev, buildEmptyRectificacionRow(row)];
    });
  };

  const handleRemoveRectificacion = (index) => {
    setRectificaciones((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRectificacionFieldChange = (index, field, value) => {
    setRectificaciones((prev) => {
      const copy = [...prev];
      copy[index] = {
        ...copy[index],
        [field]: value,
      };
      return copy;
    });
  };

  const handleLoadReplacementByIndex = async (index) => {
    const row = rectificaciones[index];
    const rbd = String(row?.rbd_reemplazo || "").trim();

    if (!rbd) {
      setRectificaciones((prev) => {
        const copy = [...prev];
        copy[index] = {
          ...copy[index],
          id_zona_reemplazo: "",
          convocatoria_reemplazo: "",
          operador_reemplazo: "",
          estado_pago_reemplazo: "",
          estado_servicio_reemplazo: "",
          replacement_loaded: false,
        };
        return copy;
      });
      return;
    }

    try {
      setLoadingReplacementIndex(index);

      const response = await axios.getEesParque(rbd);
      const data = response?.data ?? response;

      setRectificaciones((prev) => {
        const copy = [...prev];
        copy[index] = {
          ...copy[index],
          rbd_reemplazo: String(data?.rbd ?? rbd),
          id_zona_reemplazo: data?.id_zona ?? "",
          convocatoria_reemplazo: data?.convocatoria ?? "",
          operador_reemplazo: data?.nombre_operador ?? data?.operador ?? "",
          estado_pago_reemplazo: data?.estado_pago ?? "",
          estado_servicio_reemplazo:
            data?.servicio_conectividad ?? data?.estado_servicio ?? "",
          replacement_loaded: true,
        };
        return copy;
      });
    } catch (error) {
      setRectificaciones((prev) => {
        const copy = [...prev];
        copy[index] = {
          ...copy[index],
          id_zona_reemplazo: "",
          convocatoria_reemplazo: "",
          operador_reemplazo: "",
          estado_pago_reemplazo: "",
          estado_servicio_reemplazo: "",
          replacement_loaded: false,
        };
        return copy;
      });

      openSnackbar?.("No se encontró el RBD de reemplazo.", "error");
    } finally {
      setLoadingReplacementIndex(null);
    }
  };

  const resumenRows = useMemo(() => {
    if (!rectificaciones.length || !oficioSeleccionado?.tipo_oficio) return [];

    const fechaRect = formData.fecha_oficio_rectificacion
      ? dayjs(formData.fecha_oficio_rectificacion).format("YYYY-MM-DD")
      : "-";

    const tipo = oficioSeleccionado.tipo_oficio;

    return rectificaciones
      .flatMap((row) => {
        const originalBase = {
          rbd: row.rbd_original,
          id_zona: row.id_zona_original,
          convocatoria: row.convocatoria_original,
          operador: row.operador_original,
          estado_pago: row.estado_pago_original,
          motivo: row.motivo_rectificacion || "Rectificación de oficio",
        };

        const replacementBase = {
          rbd: row.rbd_reemplazo,
          id_zona: row.id_zona_reemplazo,
          convocatoria: row.convocatoria_reemplazo,
          operador: row.operador_reemplazo,
          estado_pago: row.estado_pago_reemplazo,
          motivo: row.motivo_rectificacion || "Rectificación de oficio",
        };

        if (tipo === "BAJA") {
          return [
            {
              ...originalBase,
              estado_servicio: "Alta",
              fecha_baja: "-",
              fecha_inicio_servicio: fechaRect,
            },
            {
              ...replacementBase,
              estado_servicio: "Baja",
              fecha_baja: fechaRect,
              fecha_inicio_servicio: "-",
            },
          ];
        }

        return [
          {
            ...originalBase,
            estado_servicio: "Baja",
            fecha_baja: fechaRect,
            fecha_inicio_servicio: "-",
          },
          {
            ...replacementBase,
            estado_servicio: "Alta",
            fecha_baja: "-",
            fecha_inicio_servicio: fechaRect,
          },
        ];
      })
      .filter((row) => row.rbd);
  }, [rectificaciones, oficioSeleccionado, formData.fecha_oficio_rectificacion]);

  const validateBeforeSend = () => {
    if (!rectificaciones.length) {
      openSnackbar?.("Debe seleccionar al menos un RBD a rectificar.", "warning");
      return false;
    }

    const invalidReplacement = rectificaciones.some(
      (row) => !String(row.rbd_reemplazo || "").trim() || !row.replacement_loaded
    );
    if (invalidReplacement) {
      openSnackbar?.("Debe completar y validar todos los RBD de reemplazo.", "warning");
      return false;
    }

    const invalidMotivo = rectificaciones.some(
      (row) => !String(row.motivo_rectificacion || "").trim()
    );
    if (invalidMotivo) {
      openSnackbar?.("Debe completar el motivo de rectificación.", "warning");
      return false;
    }

    if (!formData.fecha_oficio_rectificacion) {
      setEvErrorFecha(true);
      fileRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    if (!rectificacionFile?.archivo) {
      setEvErrorFile(true);
      fileRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    return true;
  };

  const handleSend = async (event) => {
    event.preventDefault();

    if (!validateBeforeSend()) return;

    try {
      setLoadingSend(true);

      const payload = {
        oficio_origen: oficioSeleccionado,
        numero_oficio_rectificacion: formData.numero_oficio_rectificacion,
        fecha_oficio_rectificacion: dayjs(formData.fecha_oficio_rectificacion).format(
          "YYYY-MM-DD"
        ),
        rectificaciones: rectificaciones.map((row) => ({
          rbd_original: row.rbd_original,
          rbd_reemplazo: row.rbd_reemplazo,
          motivo_rectificacion: row.motivo_rectificacion,
          original: {
            id_zona: row.id_zona_original,
            convocatoria: row.convocatoria_original,
            operador: row.operador_original,
            estado_pago: row.estado_pago_original,
            estado_servicio: row.estado_servicio_original,
          },
          reemplazo: {
            id_zona: row.id_zona_reemplazo,
            convocatoria: row.convocatoria_reemplazo,
            operador: row.operador_reemplazo,
            estado_pago: row.estado_pago_reemplazo,
            estado_servicio: row.estado_servicio_reemplazo,
          },
        })),
      };

      const form = new FormData();
      form.append("rectificacion_data", JSON.stringify(payload));
      form.append("file", rectificacionFile.archivo, "rectificacion.pdf");

      await axios.putRectificacionOficio(form);

      openSnackbar?.("Rectificación ingresada correctamente.", "success");

      setSelectedOficioInicio(null);
      setSelectedOficioBaja(null);
      resetLoadedData();
      setFormData({
        numero_oficio_rectificacion: "",
        fecha_oficio_rectificacion: null,
      });
      setRectificacionFile(null);
      setEvErrorFile(false);
      setEvErrorFecha(false);
    } catch (error) {
      openSnackbar?.("No se pudo guardar la rectificación.", "error");
    } finally {
      setLoadingSend(false);
    }
  };

  if (loadingInit) {
    return (
      <PageBody>
        <BreadcrumbStandard links={links} />
        <PageBgBlock>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <CircularProgress />
            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Cargando...
            </Typography>
          </Box>
        </PageBgBlock>
      </PageBody>
    );
  }

  return (
    <PageBody>
      <BreadcrumbStandard links={links} />

      <PageBgBlock>
        <form onSubmit={handleSend} id="parque_rectificacion">
          <Stack spacing={2}>
            <Typography
              variant="h1"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: "center", fontWeight: 700 }}
            >
              RECTIFICACIÓN
            </Typography>

            <Box
              justifyContent="center"
              sx={{
                maxWidth: "100%",
                margin: "0 auto",
                display: "flex",
              }}
            >
              <Typography
                variant="body"
                align="center"
                sx={{ marginBottom: "1rem", maxWidth: "34rem" }}
              >
                Si se necesita rectificar un oficio por error del documento por favor siga los
                pasos a continuación:
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle1" sx={titleStepSx}>
              PASO 1
            </Typography>

            <Box>
              <Typography variant="body2" sx={bodyStepSx}>
                Elegir el tipo de oficio que necesita rectificar y buscar por su número, luego
                cargar los datos
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <Grid container spacing={2} alignItems="flex-start">
              <Grid size={{ xs: 12, md: 6 }}>
                <Stack spacing={1} alignItems="flex-start">
                  <Autocomplete
                    fullWidth
                    size="small"
                    options={oficiosInicio}
                    value={selectedOficioInicio}
                    onChange={(_, newValue) => setSelectedOficioInicio(newValue)}
                    getOptionLabel={(option) =>
                      option?.numero_oficio
                        ? `${option.numero_oficio}`
                        : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      String(option?.id) === String(value?.id)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=""
                        placeholder="Buscar oficio de Inicio de Servicio"
                      />
                    )}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "#1565C0",
                      cursor: "pointer",
                      fontSize: "0.78rem",
                      userSelect: "none",
                    }}
                    onClick={() => handleCargarDatosOficio("INICIO_SERVICIO")}
                  >
                    <AddCircleOutlineIcon sx={{ fontSize: "0.95rem", mr: 0.5 }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "#1565C0", fontSize: "0.78rem", textAlign: "left" }}
                    >
                      Cargar datos de oficio
                    </Typography>
                  </Box>
                </Stack>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Stack spacing={1} alignItems="flex-start">
                  <Autocomplete
                    fullWidth
                    size="small"
                    options={oficiosBaja}
                    value={selectedOficioBaja}
                    onChange={(_, newValue) => setSelectedOficioBaja(newValue)}
                    getOptionLabel={(option) =>
                      option?.numero_oficio
                        ? `${option.numero_oficio}`
                        : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      String(option?.id) === String(value?.id)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=""
                        placeholder="Buscar oficio de Baja"
                      />
                    )}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "#1565C0",
                      cursor: "pointer",
                      fontSize: "0.78rem",
                      userSelect: "none",
                    }}
                    onClick={() => handleCargarDatosOficio("BAJA")}
                  >
                    <AddCircleOutlineIcon sx={{ fontSize: "0.95rem", mr: 0.5 }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "#1565C0", fontSize: "0.78rem", textAlign: "left" }}
                    >
                      Cargar datos de oficio
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle1" sx={titleStepSx}>
              PASO 2
            </Typography>

            <Box>
              <Typography variant="body2" sx={bodyStepSx}>
                Seleccionar el RBD que necesita rectificar y estos se cargarán en el paso 3
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <TableContainer component={Paper} sx={{ mb: 1, mt: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ ...headCellSx, width: 44 }} />
                    <TableCell sx={headCellSx}>RBD</TableCell>
                    <TableCell sx={headCellSx}>ID zona</TableCell>
                    <TableCell sx={headCellSx}>Convocatoria</TableCell>
                    <TableCell sx={headCellSx}>Operador</TableCell>
                    <TableCell sx={headCellSx}>Estado de Pago</TableCell>
                    <TableCell sx={headCellSx}>Estado de servicio</TableCell>
                    <TableCell sx={headCellSx}>Motivo de baja</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loadingOficio ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                        <CircularProgress size={26} />
                      </TableCell>
                    </TableRow>
                  ) : !oficioRbds.length ? (
                    <EmptyTableRow
                      colSpan={8}
                      text="Aquí se cargarán los RBD y sus datos cargados en el oficio seleccionado"
                    />
                  ) : (
                    oficioRbds.map((row) => {
                      const checked = String(selectedOldRbd) === String(row.rbd);

                      return (
                        <TableRow
                          key={row.rbd}
                          hover
                          sx={checked ? selectedStep2RowSx : undefined}
                        >
                          <TableCell>
                            <Radio
                              checked={checked}
                              onChange={() => handleSelectOldRbd(row)}
                            />
                          </TableCell>
                          <TableCell>{row.rbd}</TableCell>
                          <TableCell>{row.id_zona}</TableCell>
                          <TableCell>{row.convocatoria}</TableCell>
                          <TableCell>{row.operador}</TableCell>
                          <TableCell>{estadoPagoLabel(row.estado_pago)}</TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <FiberManualRecordIcon
                                sx={{
                                  fontSize: "0.75rem",
                                  color: servicioColor(row.estado_servicio),
                                }}
                              />
                              {estadoServicioLabel(row.estado_servicio)}
                            </Box>
                          </TableCell>
                          <TableCell>{row.motivo_baja || "-"}</TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle1" sx={titleStepSx}>
              PASO 3
            </Typography>

            <Box>
              <Typography variant="body2" sx={bodyStepSx}>
                Aquí se cargarán los RBD seleccionados en el paso anterior. Se debe dejar el
                RBD de reemplazo en el campo correspondiente y al hacerlo se cargarán los datos
                de este RBD, finalmente debe dejar el motivo de la rectificación en el campo
                correspondiente
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <TableContainer component={Paper} sx={{ mb: 1, mt: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ ...headCellSx, width: 40 }}>
                      <IconButton
                        size="small"
                        onClick={() => setRectificaciones([])}
                        disabled={!rectificaciones.length}
                      >
                        <RemoveCircleOutlineIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell sx={headCellSx}>RBD a rectificar</TableCell>
                    <TableCell sx={headCellSx}>RBD de reemplazo</TableCell>
                    <TableCell sx={headCellSx}>ID zona</TableCell>
                    <TableCell sx={headCellSx}>Convocatoria</TableCell>
                    <TableCell sx={headCellSx}>Operador</TableCell>
                    <TableCell sx={headCellSx}>Estado de Pago</TableCell>
                    <TableCell sx={headCellSx}>Estado de servicio</TableCell>
                    <TableCell sx={headCellSx}>Motivo de Rectificación</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {!rectificaciones.length ? (
                    <EmptyTableRow
                      colSpan={9}
                      text="Aquí se cargará el o los RBD de reemplazo"
                    />
                  ) : (
                    rectificaciones.map((row, index) => (
                      <TableRow key={`${row.rbd_original}-${index}`}>
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveRectificacion(index)}
                          >
                            <RemoveCircleOutlineIcon fontSize="small" />
                          </IconButton>
                        </TableCell>

                        <TableCell>{row.rbd_original}</TableCell>

                        <TableCell sx={{ minWidth: 140 }}>
                          <TextField
                            size="small"
                            sx={{ width: "100%" }}
                            value={row.rbd_reemplazo}
                            placeholder={row.rbd_original || ""}
                            onChange={(e) =>
                              handleRectificacionFieldChange(
                                index,
                                "rbd_reemplazo",
                                e.target.value
                              )
                            }
                            onBlur={() => handleLoadReplacementByIndex(index)}
                            helperText={
                              loadingReplacementIndex === index
                                ? "Cargando..."
                                : row.rbd_reemplazo && !row.replacement_loaded
                                ? "RBD no válido"
                                : ""
                            }
                          />
                        </TableCell>

                        <TableCell>{row.id_zona_reemplazo || "-"}</TableCell>
                        <TableCell>{row.convocatoria_reemplazo || "-"}</TableCell>
                        <TableCell>{row.operador_reemplazo || "-"}</TableCell>
                        <TableCell>
                          {row.estado_pago_reemplazo
                            ? estadoPagoLabel(row.estado_pago_reemplazo)
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {row.estado_servicio_reemplazo ? (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <FiberManualRecordIcon
                                sx={{
                                  fontSize: "0.75rem",
                                  color: servicioColor(row.estado_servicio_reemplazo),
                                }}
                              />
                              {estadoServicioLabel(row.estado_servicio_reemplazo)}
                            </Box>
                          ) : (
                            "-"
                          )}
                        </TableCell>

                        <TableCell sx={{ minWidth: 220 }}>
                          <TextField
                            multiline
                            minRows={2}
                            maxRows={4}
                            size="small"
                            sx={{ width: "100%" }}
                            value={row.motivo_rectificacion}
                            onChange={(e) =>
                              handleRectificacionFieldChange(
                                index,
                                "motivo_rectificacion",
                                e.target.value
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle1" sx={titleStepSx}>
              PASO 4
            </Typography>

            <Box>
              <Typography variant="body2" sx={bodyStepSx}>
                Dejar los datos del oficio de rectificación
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <NumericFormat
                  customInput={TextField}
                  label="N° de oficio de Rectificación"
                  value={formData.numero_oficio_rectificacion}
                  onValueChange={(newValue) =>
                    setFormData((prev) => ({
                      ...prev,
                      numero_oficio_rectificacion: newValue.value,
                    }))
                  }
                  allowNegative={false}
                  size="small"
                  sx={{ width: "100%" }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={"es"}
                  localeText={
                    esES.components.MuiLocalizationProvider.defaultProps.localeText
                  }
                >
                  <DatePicker
                    label="Fecha de oficio de rectificación"
                    value={formData.fecha_oficio_rectificacion}
                    sx={{ width: "100%" }}
                    slotProps={{
                      textField: {
                        size: "small",
                        error: evErrorFecha,
                        helperText: evErrorFecha
                          ? "Debe ingresar la fecha de oficio de rectificación"
                          : "",
                      },
                    }}
                    onChange={(newValue) => {
                      setEvErrorFecha(false);
                      setFormData((prev) => ({
                        ...prev,
                        fecha_oficio_rectificacion: newValue,
                      }));
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid size={12}>
                <Box ref={fileRef}>
                  <InputFile
                    onFileSelect={setFileRectificacion}
                    fileType="pdf"
                    placeholder="Oficio de rectificación"
                    buttonText="Subir archivo"
                    sizeBtnGrid={3}
                  />
                  {evErrorFile && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      Debe adjuntar oficio de rectificación
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle1" sx={titleStepSx}>
              RESUMEN
            </Typography>

            <Box>
              <Typography variant="body2" sx={bodyStepSx}>
                A continuación podrá revisar el detalle de los estados en que quedarán los RBD
              </Typography>
            </Box>

            <Divider sx={{ my: 1 }} />

            <TableContainer component={Paper} sx={{ mb: 1, mt: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={headCellSx}>RBD</TableCell>
                    <TableCell sx={headCellSx}>ID zona</TableCell>
                    <TableCell sx={headCellSx}>Convocatoria</TableCell>
                    <TableCell sx={headCellSx}>Operador</TableCell>
                    <TableCell sx={headCellSx}>Estado de Pago</TableCell>
                    <TableCell sx={headCellSx}>Estado de servicio</TableCell>
                    <TableCell sx={headCellSx}>Fecha de baja</TableCell>
                    <TableCell sx={headCellSx}>Fecha de Inicio servicio</TableCell>
                    <TableCell sx={headCellSx}>Motivo de la baja</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {!resumenRows.length ? (
                    <EmptyTableRow
                      colSpan={9}
                      text="Aquí se cargarán los RBD y sus datos correctos posterior al paso 1, 2 y 3"
                    />
                  ) : (
                    resumenRows.map((row, idx) => (
                      <TableRow key={`${row.rbd}-${idx}`}>
                        <TableCell>{row.rbd}</TableCell>
                        <TableCell>{row.id_zona || "-"}</TableCell>
                        <TableCell>{row.convocatoria || "-"}</TableCell>
                        <TableCell>{row.operador || "-"}</TableCell>
                        <TableCell>{estadoPagoLabel(row.estado_pago)}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <FiberManualRecordIcon
                              sx={{
                                fontSize: "0.75rem",
                                color: servicioColor(row.estado_servicio),
                              }}
                            />
                            {estadoServicioLabel(row.estado_servicio)}
                          </Box>
                        </TableCell>
                        <TableCell>{row.fecha_baja || "-"}</TableCell>
                        <TableCell>{row.fecha_inicio_servicio || "-"}</TableCell>
                        <TableCell>{row.motivo || "-"}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ margin: "auto", marginTop: "1.5rem" }}>
              <PageButtonBlack
                form="parque_rectificacion"
                loading={loadingSend}
                disabled={!rectificaciones.length}
                sx={!rectificaciones.length ? disabledPrimaryButtonSx : undefined}
              >
                Hacer rectificación
              </PageButtonBlack>
            </Box>
          </Stack>
        </form>
      </PageBgBlock>
    </PageBody>
  );
}